'use strict';

require('../../style/index.less');

require('./index.less');

require('../../button/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/dropdown/style/index.js
 ** module id = 63
 ** module chunks = 0
 **/